export default __webpack_public_path__ + "assets/lithuania-flag.png";